import React from "react";
import { AppBar, Toolbar, IconButton, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import "./style.css";

export default ({ setSignedIn, displayBackButton }) => {
  const history = useHistory();
  const logout = () => {
    setSignedIn(false);
    history.push("/");
  };

  const goBack = () => {
    history.goBack();
  };

  return (
    <AppBar position="static" color="default" className="AppBar">
      <Toolbar className="TopBar">
        {displayBackButton && (
          <div className="BackButton">
            <IconButton onClick={goBack}>
              <ArrowBackIosIcon />
              <Typography variant="overline">Back</Typography>
            </IconButton>
          </div>
        )}

        <img src="medias/circle.png" alt="" className="Logo" />
        <IconButton onClick={logout} className="Logout">
          <ExitToAppIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};
